import { toast } from "react-toastify";
import axios from "axios";
import settings from "utils/settings";
import defaultErrorHandler from "actions/global/default-error-handler";
import { requestCommonSearch } from "../../common/requests";
import {
  SCOOTER_TRIP_LOADING,
  SCOOTER_TRIP_ERROR,

  SCOOTER_TRIP_LIST,
  SCOOTER_TRIP_PATH,
  SCOOTER_TRIP_UPDATE,
} from "./constants";

const scooterUrl = `${settings.scooterUrl}api/`;
const ENDPOINT = "admin/trip";

export const setLoading = (status) => ({
  type: SCOOTER_TRIP_LOADING,
  payload: status
});

export const search = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, page, size, sort, filters, scooterUrl)
    .then(response => {
      dispatch({
        type: SCOOTER_TRIP_LIST,
        payload: response
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, SCOOTER_TRIP_ERROR));
    });
};

export const getPath = id => dispatch => {
  dispatch(setLoading(true));
  axios.get(`${scooterUrl}${ENDPOINT}/${id}/path`)
    .then((response) => {
      dispatch({
        type: SCOOTER_TRIP_PATH,
        payload: response.data.content
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, SCOOTER_TRIP_ERROR));
    });
};

/**
 * Update Scooter Trip.
 * @param {number} id
 * @param {object} data
 * @param {string|null} data.billingModeTariff
 * @param {number|null} data.duration
 * @returns {(function(*): void)|*}
 */
export const updateTrip = (id, data) => dispatch => {
  if (data.billingModeTariff === null) delete data.billingModeTariff;
  if (data.duration === null) delete data.duration;

  dispatch(setLoading(true));
  axios.patch(`${scooterUrl}${ENDPOINT}/${id}/reconcile`, data)
    .then((response) => {
      dispatch({
        type: SCOOTER_TRIP_UPDATE,
        payload: response.data.content
      });
      toast("Trip billing tariff updated successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch(() => {
      toast("Trip billing tariff did not updated. Something went wrong.", {
        type: toast.TYPE.ERROR,
      });
    });
};



// WEBPACK FOOTER //
// ./src/actions/scooter/trip/actions.js